function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M8.575 3.074c.26.125.425.388.425.676v10.5c0 .288-.165.551-.425.676s-.568.09-.794-.09L4.237 12H1.5c-.414 0-.75-.336-.75-.75v-4.5c0-.414.336-.75.75-.75h2.737L7.78 3.164c.226-.18.534-.215.794-.09zM7.5 5.31L4.969 7.336c-.133.106-.299.164-.469.164H2.25v3H4.5c.17 0 .336.058.469.164L7.5 12.69V5.31zM17.78 6.22c.293.293.293.767 0 1.06l-4.5 4.5c-.293.293-.767.293-1.06 0-.293-.293-.293-.767 0-1.06l4.5-4.5c.293-.293.767-.293 1.06 0z",
  clipRule: "evenodd"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M12.22 6.22c.293-.293.767-.293 1.06 0l4.5 4.5c.293.293.293.767 0 1.06-.293.293-.767.293-1.06 0l-4.5-4.5c-.293-.293-.293-.767 0-1.06z",
  clipRule: "evenodd"
});

var SvgIcVolumeOff = function SvgIcVolumeOff(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcVolumeOff, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_volume_off.28acf30e.svg";
export { ForwardRef as ReactComponent };